











import { Component , Vue } from 'vue-property-decorator';
import '../assets/css/Loader.scss';
import { LoaderEvent } from '../types/event';
import { EventBus } from '../main';
import { MedTransGoConstants } from '../util/constants';
@Component({})
export default class Loader extends Vue {

    private loaderEvent: LoaderEvent = {show: false};

    public mounted() {
         EventBus.$on(MedTransGoConstants.EVENT_SHOW_LOADER, (loaderEvent: LoaderEvent) => {
            this.loaderEvent = loaderEvent;
        });
    }

}
